type GalleryPresetOption = {
    id?: number | string
    name?: string
    variables?: Record<string, any>
}

const GALLERY_PRESET_LABELS: Record<number, string> = {
    228: 'Grade ampla 4 colunas',
    235: 'Flex amplo 4 colunas',
    236: 'Grade espaçada 4 colunas',
    237: 'Flex recortado 4 colunas',
    238: 'Grade 3 colunas',
    239: 'Carrossel em destaque',
    240: 'Grade com sidebar',
    241: 'Flex com sidebar',
    242: 'Grade recortada sem título',
}

export const getGalleryPresetFamily = (galleryType?: string | null) => {
    const normalizedType = String(galleryType ?? 'gallery-isotope').toLowerCase()

    if (normalizedType === 'gallery-default') return 'isotope'
    if (normalizedType.includes('carousel')) return 'carousel'
    if (normalizedType.includes('imageflex')) return 'imageflex'
    if (normalizedType.includes('flex')) return 'flex'

    return 'isotope'
}

const buildFallbackLabel = (option: GalleryPresetOption) => {
    const variables = option.variables ?? {}
    const family = getGalleryPresetFamily(variables.maincontent_gallery)
    const items = Number(variables.maincontent_gallery_items ?? 0)
    const crop = String(variables.maincontent_gallery_items_crop ?? '0') === '1'
    const hasSidebarExtras = ['maincontent_sidebar', 'maincontent_comments', 'maincontent_share_buttons']
        .some(key => String(variables[key] ?? '0') === '1')

    if (family === 'carousel') return 'Carrossel em destaque'

    if (family === 'flex' || family === 'imageflex') {
        if (hasSidebarExtras) return 'Flex com sidebar'
        if (crop && items > 0) return `Flex recortado ${items} colunas`
        if (items > 0) return `Flex ${items} colunas`

        return 'Galeria flex'
    }

    if (hasSidebarExtras) return 'Grade com sidebar'
    if (crop && items > 0) return `Grade recortada ${items} colunas`
    if (items > 0) return `Grade ${items} colunas`

    return option.name || 'Galeria personalizada'
}

export const getGalleryPresetLabel = (option: GalleryPresetOption) => {
    const presetId = Number(option.id)

    if (Number.isFinite(presetId) && GALLERY_PRESET_LABELS[presetId]) {
        return GALLERY_PRESET_LABELS[presetId]
    }

    return buildFallbackLabel(option)
}

export const normalizeGalleryPresetOption = (option: GalleryPresetOption) => ({
    ...option,
    name: getGalleryPresetLabel(option),
})
